/* eslint-disable spaced-comment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { Switch } from 'react-router-dom';
import { graphql } from 'react-apollo';

import CustomerRoute from '../routes/CustomerRoute';
import Dashboard from '../pages/customer/CustomerDashboard';
import FactsheetDashboard from '../pages/customer/CustomerFactsheetDashboard';
import OrganizationalDetails from '../pages/factsheet/OrganizationalDetails';
import ManagementDetails from '../pages/factsheet/ManagementDetails';
import ProposedLoans from '../pages/factsheet/ProposedLoans';
import Securities from '../pages/factsheet/Securities';
import PresentBankingArrangements from '../pages/factsheet/PresentBankingArrangements';
import PbaRepaymentSchedule from '../pages/factsheet/PbaRepaymentSchedule';
import PbaSecurities from '../pages/factsheet/PbaSecurities';
import AdditionalDetails from '../pages/factsheet/AdditionalDetails';
import CMA from '../pages/customer/CMA';
import AssociateConcerns from '../pages/factsheet/AssociateConcerns';
import CustomerDocs from '../pages/customer/CustomerDocuments';
import CustomerTasks from '../pages/customer/CustomerTasks';
import FactsheetCreate from '../pages/factsheet/FactsheetCreate';

import getCustomerQuery from '../graphql/queries/getCustomerQuery.graphql';


class CustomerLayout extends Component {
  state = {
  };

  render() {
    const { path, params } = this.props.match;
    const { loading, customer, tasks, docs } = this.props.data;
    if (loading) {
      return (<Spin size="large" />);
    }
    return (
      <Switch>
        <CustomerRoute exact path={path} component={Dashboard} customerName={customer.name} selectedKey="customer-dashboard" />
        {/*<CustomerRoute path={`${path}/tasks`} component={CustomerTasks} customerName={customer.name} selectedKey="customer-tasks" componentProps={{ customer_id: params.id, tasks }} />*/}
        {/*<CustomerRoute*/}
          {/*path={`${path}/documents`}*/}
          {/*component={CustomerDocs}*/}
          {/*customerName={customer.name}*/}
          {/*selectedKey="customer-documents"*/}
          {/*componentProps={{ docs }}*/}
        {/*/>*/}
        {/*<CustomerRoute*/}
          {/*path={`${path}/factsheet/od`}*/}
          {/*component={OrganizationalDetails}*/}
          {/*customerName={customer.name}*/}
          {/*selectedKey="customer-factsheet-od"*/}
          {/*componentProps={{*/}
            {/*docs: docs.filter((doc) => {*/}
              {/*let ret = false;*/}
              {/*doc.tags.forEach((dTag) => {*/}
                {/*if (dTag.tag === 'customer-kyc' && dTag.tag !== 'address') ret = true;*/}
              {/*});*/}
              {/*return ret;*/}
            {/*}),*/}
          {/*}}*/}
        {/*/>*/}
        {/*<CustomerRoute path={`${path}/factsheet/md`} component={ManagementDetails} customerName={customer.name} selectedKey="customer-factsheet-md" />*/}
        {/*<CustomerRoute path={`${path}/factsheet/pl`} component={ProposedLoans} customerName={customer.name} selectedKey="customer-factsheet-pl" />*/}
        {/*<CustomerRoute path={`${path}/factsheet/securities`} component={Securities} customerName={customer.name} selectedKey="customer-factsheet-securities" />*/}
        {/*<CustomerRoute exact path={`${path}/factsheet/pba`} component={PresentBankingArrangements} customerName={customer.name} selectedKey="customer-factsheet-pba" />*/}
        {/*<CustomerRoute path={`${path}/factsheet/pba/:pba_id/rs`} component={PbaRepaymentSchedule} customerName={customer.name} selectedKey="customer-factsheet-pba" />*/}
        {/*<CustomerRoute path={`${path}/factsheet/pba/:pba_id/securities`} component={PbaSecurities} customerName={customer.name} selectedKey="customer-factsheet-pba" />*/}
        {/*<CustomerRoute path={`${path}/factsheet/addDetails`} component={AdditionalDetails} customerName={customer.name} selectedKey="customer-factsheet-add-details" />*/}
        {/*<CustomerRoute path={`${path}/factsheet/ac`} component={AssociateConcerns} customerName={customer.name} selectedKey="customer-factsheet-ac" />*/}
        <CustomerRoute path={`${path}/factsheet`} component={FactsheetCreate} customerName={customer.name} selectedKey="customer-factsheet-dashboard" />
        <CustomerRoute path={`${path}/cma`} component={CMA} customerName={customer.name} selectedKey="cma" />
      </Switch>
    );
  }
}

CustomerLayout.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    customer: PropTypes.object,
    tasks: PropTypes.array,
    docs: PropTypes.array,
  }).isRequired,
};

export default graphql(getCustomerQuery, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(CustomerLayout);



// WEBPACK FOOTER //
// ./src/layouts/CustomerLayout.jsx